import { create } from 'zustand';

type Store = {
  wishlist: any[];
  setWishList: (value: any) => void;
  clearWishList: () => void
};

export const useWishListStore = create<Store>((set) => ({
  wishlist: [],

  setWishList: (value: any) => set({ wishlist: value }),
  clearWishList: () => set({ wishlist: [] }),
}));


